import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';

import { useGuide } from '@app/hooks';
import { setUrlParameters } from '@app/components/common/table/utils';
import { DateRange } from '@app/components/common/date-range-picker/types';
import { API_FEAT_DATE_FORMAT } from '@app/utils';

import { openStatuses } from '../components/select-status-field';

export const useFilterState = () => {
  const getStatuses = useGuide('service_status');
  const [selectedStatuses, _setSelectedStatuses] = useState<EntityBase[]>([]);
  const [period, _setPeriod] = useState<DateRange | undefined>();

  const [statuses, setStatuses] = useState<EntityBase[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const data = await getStatuses();
      setStatuses(data);

      const query = new URLSearchParams(window.location.search); 
      const selected = query.get('statuses')?.split(',').map(Number);
      const period = query.get('period')?.split(':').map((v) => moment(v));
      

      if (selected && Array.isArray(selected)) {
        _setSelectedStatuses(data.filter(({ id }) => selected.includes(Number(id)) ));
      } else {
        _setSelectedStatuses(openStatuses);
      }

      if (period && Array.isArray(period) && period.length === 2) {
        _setPeriod({
          startDate: period[0],
          endDate: period[1],
        });
      }
       

      setIsLoading(false);
    })();
  }, []);

  const setSelectedStatuses = useCallback((newStatuses: EntityBase[]) => {
    setUrlParameters({
      ...(period ? { period: `${period.startDate.format(API_FEAT_DATE_FORMAT)}:${period.endDate.format(API_FEAT_DATE_FORMAT)}` } : { period: '' }),
      statuses: newStatuses ? newStatuses.map(({ id }) => id).join(',') : '',
    });
    _setSelectedStatuses(newStatuses);
  }, [period]);

  const setPeriod = useCallback((range: DateRange | undefined) => {
    setUrlParameters({
      ...(range ? { period: `${range.startDate.format(API_FEAT_DATE_FORMAT)}:${range.endDate.format(API_FEAT_DATE_FORMAT)}` } : { period: '' }),
      statuses: selectedStatuses ? selectedStatuses.map(({ id }) => id).join(',') : '',
    });
    _setPeriod(range);
  }, [selectedStatuses]);

  return {
    isLoading,
    statuses,
    selectedStatuses,
    setSelectedStatuses,
    period,
    setPeriod
  };
};